module.exports = __webpack_public_path__ + "static/media/resources-bg.fe3bc113.svg";